<template>
  <v-card class="d-flex flex-column my-4">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
      <h3 style="color: #1976d2;">Praxis-Wissen</h3>
      <h2 v-if="content.cont_title == 'Prophylaxe'">ZZV & Prophylaxe </h2>
      <h2 v-if="content.cont_title == 'FehlendeZaehne'">ZZV & fehlende Zähne </h2>
      <h2 v-if="content.cont_title == 'AngerateneBehandlung'">ZZV & angeratene Behandlung </h2>
    </div>
    
    <div class="pa-4" >
      <span v-if="content.cont_title == 'AngerateneBehandlung'">
       
        <p>
          Wenn eine Behandlung vor Vertragsabschluss bereits absehbar, angeraten oder sogar geplant wurde, ist sie vom Versicherungsschutz ausgeschlossen – selbst wenn sie noch nicht begonnen wurde?
        </p>
      </span>
      <span v-if="content.cont_title == 'FehlendeZaehne'">
     Zahnzusatzversicherung & fehlende Zähne
      <ul class="mt-2">
        <li>
        Können fehlende Zähne noch versichert werden?
          </li>
          <li>
          Was muss der Zahnarzt beachten?
          </li>
         
        </ul>
      </span>

      <span v-if="content.cont_title == 'Prophylaxe'">
      Hintergrundwissen für zahnmedizinisches Fachpersonal zum Thema Zahnzusatzversicherung  & Prophylaxe.
      <ul class="mt-2">
        <li>
            <a
              href="/dist/praxiswissen/PraxisWissen_Kinderprophylaxe.pdf"
              target="_blank"
              >ZZV-PraxisWissen PZR für Kinder </a
            > <sup class="text-green">neu</sup>
          </li>
          <li>
            <a
              href="/dist/praxiswissen/PraxisWissen_Prophylaxe.pdf"
              target="_blank"
              >ZZV-PraxisWissen Professionelle Zahnreinigung </a
            >
          </li>
          <li>
            <a
              href="/dist/praxiswissen/Waizmann_Praxisumfrage_Prophylaxe.pdf"
              target="_blank"
              >Praxisumfrage 2024 Prophylaxe - Ergebnisse</a
            >
          </li>
        </ul>
      </span>
    </div>
    <div class="pa-3 border-bottom" >
      <v-btn 
        v-if="content.cont_title != ''" 
        :to="`/praxiswissen/${content.cont_title}`" 
        color="primary" 
        block
      >
        Praxiswissen anzeigen
      </v-btn> </div>

  </v-card>
</template>

<script setup>

import { defineProps } from "vue";
const props = defineProps({
  content: {
    type: Object,
    required: true
  }
});
console.log(props.content)

</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #088a85;
}

.text-primary {
  color: #088a85;
}
</style>
